import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { useSSRStorePrefill } from "../../../store/reducers";
import { MultiProductWriteReviewForm } from "../MultiProductWriteReviewForm";
import { prefillSSRMultiProductWriteReviewData } from "../ssr";

type IProps = Immutable<templates.MultiProductWriteReviewFormTemplate>;

export const MultiProductWriteReviewSSR = (
    props: IProps,
): React.JSX.Element => {
    useSSRStorePrefill(
        {
            products_data: props.products_data,
            review_templates_data: props.review_templates_data,
            reviews_info_map: props.reviews_info_map,
            email: props.email,
        },
        prefillSSRMultiProductWriteReviewData,
    );

    return (
        <MultiProductWriteReviewForm
            reviewsInfoMapJSON={props.reviews_info_map}
            email={props.email}
        />
    );
};
